'use strict';

const photoSwipe = require('./components/photoswipe-base');

const selectors = {
    productCarouselMain: '.js-product-images-main',
    storeImageCarouselMain: '.js-store-images-main'
};

/**
* Initializes the file
*/
function init() {
    $(document).ready(() => {
        photoSwipe.initPhotoSwipeFromDOM(selectors.productCarouselMain);
        photoSwipe.initPhotoSwipeFromDOM(selectors.storeImageCarouselMain);
    });
}

module.exports = {
    init: init
};
